module.exports = __webpack_public_path__ + "img/jiaolun.68cf764d.jpeg";